import { Typography, Box } from '@mui/material';
import LanguageDropdown from '../LanguageDropdown';

interface OnboardingHeaderProps {
  title: string;
  currentLanguage: string;
  changeLanguage: (language: string) => void;
}

const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({ title, currentLanguage, changeLanguage }) => {
  return (
    <Box className="app-header" sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex', padding: 3, background: 'linear-gradient(to bottom, #000000, #434343)', gap: 3 }}>
      <Typography sx={{ textAlign: 'center', color: '#C7A46E', fontSize: 'clamp(1.5rem, 3.5vw, 3.5rem)' }}>{title}</Typography>
      <Box sx={{ position: 'absolute', right: 0 }}>
        <LanguageDropdown currentLanguage={currentLanguage} changeLanguage={changeLanguage} />
      </Box>
    </Box>
  );
};

export default OnboardingHeader;
